import React from "react"

function ChevronLeftIcon() {
    return (
        <svg width="10" height="16" viewBox="0 0 10 16" fill="inherit" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 14L7.962 16L-2.98023e-07 8L7.962 -4.76837e-07L10 2L4 8L10 14Z" />
        </svg>
    )
}

export default ChevronLeftIcon
